import React from 'react';
import PropTypes from 'prop-types';
import ProfilePic from "../../ProfilePic";
import assets from "../../../util/assets";
import {getStatus} from "../../../util/utility";
import messaging_utility from "../../../util/messaging/utility";
import "./index.css";

UserListItem.propTypes = {
    profile_pic: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    datetime: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    unreadCount: PropTypes.number.isRequired,
    isMuted: PropTypes.bool.isRequired,
    item: PropTypes.object.isRequired,
    action: PropTypes.func.isRequired,
};

UserListItem.defaultProps = {
    profile_pic: assets.user_placeholder,
    username: 'username',
    status: 0,
}

function UserListItem(props) {

    return (
        <div className="user-list-item display-flex-align-center cursor-pointer" onClick={() => {
            props.action(props.item)
        }}>

            <div className="display-flex-align-center">
                <ProfilePic
                    profile_pic={props.profile_pic}
                    is_verified={props.item.metaData.is_broadcaster_verified === "1" ? 1 : 0}
                    user_type={messaging_utility.getUserType(props)}/>

                <div className="user-list-display-flex-justify-content-flex-start">
                    <div className="broadcaster-profile-container-broadcaster-name">
                        <span className="user-list-username">{props.username}</span>
                        <img src={getStatus(props.status)} style={{paddingLeft: 5}}
                             alt="user status"/>
                    </div>
                    <div className="user-list-message">{props.message}</div>
                </div>
            </div>

            <div className="user-list-display-flex-justify-content-flex-end">
                <div className="user-list-datetime">{props.datetime}</div>
                {
                    props.unreadCount > 0 && <div className="user-list-unread-count">{props.unreadCount}</div>
                }
            </div>
        </div>
    );
}

export default UserListItem;